import { render, staticRenderFns } from "./SpeechWrapper.vue?vue&type=template&id=75527b04&"
import script from "./SpeechWrapper.vue?vue&type=script&lang=js&"
export * from "./SpeechWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SpeechWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports